import { Controller } from '@hotwired/stimulus';

class PinCodeSetupController extends Controller {
  static targets = ['pinCode', 'pinCodeConfirmation', 'submit', 'confirmationHelp'];
  static values = { length: { type: Number, default: 8 } };

  connect() {
    this.updateSubmitState();
  }

  handlePinCodeInput() {
    this.validatePinCodeFormat(this.pinCodeTarget);
    this.updateSubmitState();
  }

  handlePinCodeConfirmationInput() {
    this.validatePinCodeFormat(this.pinCodeConfirmationTarget);
    this.updateSubmitState();
  }

  validatePinCodeFormat(input) {
    input.value = input.value.replace(/\D/g, '');

    if (input.value.length > this.lengthValue) {
      input.value = input.value.slice(0, this.lengthValue);
    }
  }

  updateSubmitState() {
    const pinCode = this.pinCodeTarget.value;
    const pinCodeConfirmation = this.pinCodeConfirmationTarget.value;

    const isValid = pinCode.length === this.lengthValue &&
                   pinCode === pinCodeConfirmation &&
                   pinCode !== '';

    this.submitTarget.disabled = !isValid;

    if (this.hasConfirmationHelpTarget) {
      if (pinCode === pinCodeConfirmation) {
        this.confirmationHelpTarget.textContent = '';
        this.confirmationHelpTarget.classList.remove('text-danger');
      } else {
        this.confirmationHelpTarget.textContent = 'Les codes renseignés ne sont pas identiques';
        this.confirmationHelpTarget.classList.add('text-danger');
      }
    }
  }
}

export default PinCodeSetupController;
